import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader"; 

import { useGlobalState } from "../../contexts/GlobalContext";
import { fetchUserInfoProxy } from "../../utils/helpers/api";
import { getSurveyId } from "../../utils/helpers/api";
import { Routes } from "../../utils/constants";

const SurveyMember: React.FC = () => {
  const { t } = useTranslation();
  const { globalState, setStateValue } = useGlobalState();
  const { user } = globalState;
  const navigate = useNavigate();
  
  const [error, setError] = useState(false);
  const [isIncompleteProfile, setIsIncompleteProfile] = useState(false);
  const [user_id, setUserId] = useState<string>(user?.user_id ?? '');
  const [webLinkId, setWebLinkId] = useState<string>('');

  const [isRedirecting, setIsRedirecting] = useState(false);
  const [targetSurveyUrl, setTargetSurveyUrl] = useState<string>('');

  useEffect(() => {
    if (user && user?.user_metadata?.user_status !== 2) {
      const urlParams = new URLSearchParams(window.location.search);
      const linkId = urlParams.get("web_link_id");
      setIsIncompleteProfile(true);
      const timer = setTimeout(() => {
        navigate(Routes.USERSETTING, {
          state: { surveyMember: true, webLinkId:linkId }
        });      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [user, navigate]);

  const getNativeSurveyUrl: () => Promise<any> = useCallback(async () => {
    if (user?.user_metadata?.user_status !== 2) {
      return; 
    }

    try {
      // Promise.allSettledで両方の非同期関数を同時実行
      const [responseResult, surveyResult] = await Promise.allSettled([
        fetchUserInfoProxy(),
        getSurveyId(webLinkId),
      ]);
      // 両方の非同期関数が成功した場合のみ処理を続行
      if (responseResult.status === "fulfilled" && surveyResult.status === "fulfilled") {
        const user_id_hash = responseResult.value?.data?.user_id_hash ?? "";
        const surveyId = surveyResult.value.data.surveyId;
        const surveyUrl = `https://jp.surveymonkey.com/r/${webLinkId}?survey_id=${surveyId}&user_id=${user_id}&id=${user_id_hash}`;
        setTargetSurveyUrl(surveyUrl);
        setIsRedirecting(true);
      } else {
        setError(true);
        setStateValue("loader", false);
      }
    } catch (error) {
      setError(true);
      setStateValue("loader", false);
    }
  }, [user_id, webLinkId, user, setStateValue]);

  useEffect(() => {
    if (isRedirecting && targetSurveyUrl) {
      const timer = setTimeout(() => {
        window.location.href = targetSurveyUrl;
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isRedirecting, targetSurveyUrl]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const linkId = urlParams.get("web_link_id");
    // 画面初回アクセス時にwebLinkIdが取得できない場合はエラーを表示し他の処理させないでおく
    if (linkId === null) {
      setError(true);
      return;
    }
    // webLinkIdをstateにセット
    setWebLinkId(linkId);

    // global state側でuserが取得できてるかを確認して
    // 取得できていればuser_idをstateにセットする
    if (typeof user !== 'undefined' && user && user_id.length === 0) {
      setUserId(user.user_id);
    }
  }, [user, user_id]);

  useEffect(() => {
    if (user_id.length > 0 && webLinkId.length > 0) {
      getNativeSurveyUrl();
    }
  }, [user_id, webLinkId, getNativeSurveyUrl]);

  return (
      <div>
        {isIncompleteProfile && (
            <Box className="survey_page center mt20">
              <p className="mb4 text_err">ダウンロードには本会員登録が必要です。</p>
              <p className="mb16 text_err">入力画面へ遷移します。</p>
            </Box>
        )}

        {isRedirecting && !isIncompleteProfile && (
            <div className="components__loader">
              <div className="components__loader-spinner">
                <ScaleLoader color="#fff" height={30} loading={true} />
              </div>
            </div>
        )}

        {error && !isIncompleteProfile && !isRedirecting && (
            <Box className="survey_page center mt20">
              <p className="title_err">{t("features.survey.title_err")}</p>
              <p className="mb4 text_err"> {t("features.survey.message_err_1")} </p>
              <p className="mb16 text_err">{t("features.survey.message_err_2")}</p>
            </Box>
        )}
      </div>
  );
};

export default SurveyMember;
